//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import { Box, Grid, Typography } from '@mui/material'
import {
  PoolAccountCTO,
  PoolAccountCTOSchema,
  PoolBaseAccountCTO,
  PoolBaseAccountCTOSchema,
  PoolDynamicAccountCTO,
  PoolDynamicOverviewCTO,
  PoolFlexAccountCTO,
  PoolFlexAccountCTOSchema,
} from '@shared/sharedTypes'
import React, { useEffect } from 'react'

import { EthAddr } from '@shared/SchemaTypes'

import ViewField from '@react/components/elements/ViewField'
import { useOtChainState, useOtDispatch, useOtSelector } from '@react/redux/store'
import { useParams } from 'react-router-dom'

import { SectionHeader } from '@react/components/common/SectionHeader'
import { PoolTypeEnum } from '@shared/Enums'

import { LenderInvestmentLedger } from './LenderInvestmentLedger'

import { fetchPoolAccountCTO } from '@react/fetchers/PoolFetchers'
import { PoolDynamicAccountCTOSchema } from '@shared/PoolDynamicAccountCTO'
import { ETH_ADDR_ZERO } from '@shared/SchemaTypes'
import { poolActions } from '@react/redux/poolSlice'

export default function LenderPoolHoldings(props: {
  poolAddr?: EthAddr
  accountAddr?: EthAddr
  blockNumberSnapshot?: number
}): React.ReactElement {
  const poolAddr = (props.poolAddr ? props.poolAddr : useParams().poolAddr) as EthAddr

  const {
    stageConfiguration: { restAPIKey, serverApiBaseUrl },
    userConnection: { accountAddr: accountAddrLoggedIn },
  } = useOtChainState()

  const accountAddr = props.accountAddr ?? accountAddrLoggedIn
  const { blockNumberSnapshot } = props

  const [poolBaseAccountCTOAtBlock, setPoolBaseAccountCTOAtBlock] = React.useState<PoolBaseAccountCTO | undefined>(
    undefined
  )

  // const poolBaseAccountCTO = useOtSelector((state) =>
  //   poolAddr && accountAddr && state.poolState.poolAccountCTOs[poolAddr]
  //     ? state.poolState.poolAccountCTOs[poolAddr][accountAddr]
  //     : undefined
  // )
  const poolAccountCTOs = useOtSelector((state) => state.poolState.poolAccountCTOs)
  console.log('poolBaseAccountCTO', poolAddr, accountAddr, poolAccountCTOs)
  const poolBaseOverviewCTO = useOtSelector((state) => state.poolState.poolOverviewCTOs[poolAddr ?? ETH_ADDR_ZERO])
  const dispatch = useOtDispatch()

  const _poolDynamicOverviewCTO =
    poolBaseOverviewCTO?.poolType === PoolTypeEnum.Dynamic ? (poolBaseOverviewCTO as PoolDynamicOverviewCTO) : null
  // const poolAccountCTO =
  //   poolBaseOverviewCTO?.poolType === PoolTypeEnum.Term
  //     ? (poolBaseAccountCTOAtBlock ?? (poolBaseAccountCTO as PoolAccountCTO))
  //     : null
  // const poolFlexAccountCTO =
  //   poolBaseOverviewCTO?.poolType === PoolTypeEnum.FlexibleRate
  //     ? (poolBaseAccountCTOAtBlock ?? (poolBaseAccountCTO as PoolFlexAccountCTO))
  //     : null

  useEffect(() => {
    if (poolAddr && accountAddr && serverApiBaseUrl && restAPIKey) {
      const fetchAccountCTO = blockNumberSnapshot
        ? fetchPoolAccountCTO(serverApiBaseUrl, restAPIKey, poolAddr, accountAddr, blockNumberSnapshot)
        : fetchPoolAccountCTO(serverApiBaseUrl, restAPIKey, poolAddr, accountAddr)

      fetchAccountCTO
        .then((_poolBaseAccountCTO) => {
          setPoolBaseAccountCTOAtBlock(_poolBaseAccountCTO)
          if (!blockNumberSnapshot && _poolBaseAccountCTO) {
            dispatch(poolActions.updatePoolAccountCTO(_poolBaseAccountCTO))
          }
        })
        .catch((error) => {
          console.log('fetch error', error)
        })
    }
  }, [poolAddr, accountAddr, blockNumberSnapshot, poolBaseOverviewCTO])

  // We should refactor this into a component that identify which
  // poolType it is and then renders a dedicated component for each poolType
  const poolTermAccountCTO =
    poolBaseAccountCTOAtBlock?.poolType === PoolTypeEnum.Term
      ? (poolBaseAccountCTOAtBlock as PoolAccountCTO)
      : undefined
  const poolFlexAccountCTO =
    poolBaseAccountCTOAtBlock?.poolType === PoolTypeEnum.FlexibleRate
      ? (poolBaseAccountCTOAtBlock as PoolFlexAccountCTO)
      : undefined
  const poolDynamicAccountCTO =
    poolBaseAccountCTOAtBlock?.poolType === PoolTypeEnum.Dynamic
      ? (poolBaseAccountCTOAtBlock as PoolDynamicAccountCTO)
      : undefined
  // prettier-ignore
  /* eslint-disable prettier/prettier */

  const poolAccountCTO =
    poolBaseAccountCTOAtBlock?.poolType === PoolTypeEnum.Term
      ? (poolBaseAccountCTOAtBlock as PoolAccountCTO)
      : poolBaseAccountCTOAtBlock?.poolType === PoolTypeEnum.FlexibleRate
      ? (poolBaseAccountCTOAtBlock as PoolFlexAccountCTO)
      : poolBaseAccountCTOAtBlock?.poolType === PoolTypeEnum.Dynamic
      ? (poolBaseAccountCTOAtBlock as PoolDynamicAccountCTO)
      : undefined

  console.log('QQQQ poolDynamicAccountCTO', poolDynamicAccountCTO, poolBaseAccountCTOAtBlock)

  console.log('QQQQpoolFlexAccountCTO', poolFlexAccountCTO)
  if (poolBaseAccountCTOAtBlock && poolBaseOverviewCTO) {
    return (
      <Box>
        <Box px={3} py={2} sx={{ flexGrow: 1 }}>
          <SectionHeader>
            <Typography variant={'captionBold'}>My Investment Details</Typography>
          </SectionHeader>

          <Grid container spacing={8} sx={{ padding: '24px', marginTop: '-24px', marginLeft: '0px' }}>
            {poolDynamicAccountCTO && _poolDynamicOverviewCTO && (
              <>
                <Grid item xs={12} sm={6}>
                  <ViewField
                    dataObject={poolDynamicAccountCTO}
                    fieldSchema={PoolDynamicAccountCTOSchema.describe().fields.principalEarningInterest}
                    liquidityTokenSymbol={_poolDynamicOverviewCTO.liquidityTokenSymbol}
                  ></ViewField>
                </Grid>
                {/* <Grid item xs={12} sm={6}>
                  <ViewField
                    dataObject={poolDynamicAccountCTO}
                    fieldSchema={PoolDynamicAccountCTOSchema.describe().fields.interestAccrued}
                    liquidityTokenSymbol={poolBaseOverviewCTO.liquidityTokenSymbol}
                  ></ViewField>
                </Grid> */}

                <Grid item xs={12} sm={6}>
                  <ViewField
                    dataObject={poolBaseAccountCTOAtBlock}
                    poolTokenSymbol={poolBaseOverviewCTO.symbol}
                    fieldSchema={PoolBaseAccountCTOSchema.describe().fields.tokenBalance}
                    toolTip="The number of vault tokens you currently hold."
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <ViewField
                    dataObject={poolDynamicAccountCTO}
                    fieldSchema={PoolDynamicAccountCTOSchema.describe().fields.assetsDeposited}
                    liquidityTokenSymbol={poolBaseOverviewCTO.liquidityTokenSymbol}
                  ></ViewField>
                </Grid>
                {/* <Grid item xs={12} sm={6}>
                  <ViewField
                    dataObject={poolBaseAccountCTOAtBlock}
                    poolTokenSymbol={poolBaseOverviewCTO.symbol}
                    fieldSchema={PoolDynamicAccountCTOSchema.describe().fields.tokenBalance}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <ViewField
                    dataObject={poolDynamicAccountCTO}
                    poolTokenSymbol={poolBaseOverviewCTO.symbol}
                    fieldSchema={PoolDynamicAccountCTOSchema.describe().fields.maxWithdrawRequest}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <ViewField
                    dataObject={poolDynamicAccountCTO}
                    poolTokenSymbol={poolBaseOverviewCTO.symbol}
                    fieldSchema={PoolDynamicAccountCTOSchema.describe().fields.maxRedeemRequest}
                  />
                </Grid> */}

                {/* <Grid item xs={12} sm={6}>
                  <ViewField
                    dataObject={poolDynamicAccountCTO}
                    poolTokenSymbol={poolBaseOverviewCTO.symbol}
                    fieldSchema={PoolDynamicAccountCTOSchema.describe().fields.requestedSharesOf}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <ViewField
                    dataObject={poolDynamicAccountCTO}
                    poolTokenSymbol={poolBaseOverviewCTO.symbol}
                    fieldSchema={PoolDynamicAccountCTOSchema.describe().fields.requestedAssetsOf}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <ViewField
                    dataObject={poolDynamicAccountCTO}
                    poolTokenSymbol={poolBaseOverviewCTO.symbol}
                    fieldSchema={PoolDynamicAccountCTOSchema.describe().fields.acceptedShares}
                  />
                </Grid> */}

                {/* <Grid item xs={12} sm={6}>
                  <ViewField
                    dataObject={poolDynamicAccountCTO}
                    poolTokenSymbol={poolBaseOverviewCTO.symbol}
                    fieldSchema={PoolDynamicAccountCTOSchema.describe().fields.assetsDeposited}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <ViewField
                    dataObject={poolDynamicAccountCTO}
                    poolTokenSymbol={poolBaseOverviewCTO.symbol}
                    fieldSchema={PoolDynamicAccountCTOSchema.describe().fields.assetsWithdrawn}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <ViewField
                    dataObject={poolDynamicAccountCTO}
                    poolTokenSymbol={poolBaseOverviewCTO.symbol}
                    fieldSchema={PoolDynamicAccountCTOSchema.describe().fields.interestRate}
                  />
                </Grid> */}
              </>
            )}
            {poolFlexAccountCTO && (
              <>
                <Grid item xs={12} sm={6}>
                  <ViewField
                    dataObject={poolFlexAccountCTO}
                    fieldSchema={PoolFlexAccountCTOSchema.describe().fields.principalEarningInterest}
                    liquidityTokenSymbol={poolBaseOverviewCTO.liquidityTokenSymbol}
                  ></ViewField>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <ViewField
                    dataObject={poolFlexAccountCTO}
                    fieldSchema={PoolFlexAccountCTOSchema.describe().fields.interestAccrued}
                    liquidityTokenSymbol={poolBaseOverviewCTO.liquidityTokenSymbol}
                  ></ViewField>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <ViewField
                    dataObject={poolBaseAccountCTOAtBlock}
                    poolTokenSymbol={poolBaseOverviewCTO.symbol}
                    fieldSchema={PoolBaseAccountCTOSchema.describe().fields.tokenBalance}
                    toolTip="The number of vault tokens you currently hold."
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <ViewField
                    dataObject={poolFlexAccountCTO}
                    fieldSchema={PoolFlexAccountCTOSchema.describe().fields.assetsDeposited}
                    liquidityTokenSymbol={poolBaseOverviewCTO.liquidityTokenSymbol}
                  ></ViewField>
                </Grid>
              </>
            )}
            {poolAccountCTO && (
              <>
                <Grid item xs={12} sm={6}>
                  <ViewField
                    dataObject={poolBaseAccountCTOAtBlock}
                    poolTokenSymbol={poolBaseOverviewCTO.symbol}
                    fieldSchema={PoolBaseAccountCTOSchema.describe().fields.tokenBalance}
                    toolTip="The number of vault tokens you currently hold."
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <ViewField
                    dataObject={poolAccountCTO}
                    fieldSchema={PoolAccountCTOSchema.describe().fields.maxWithdrawRequest}
                    poolTokenSymbol={poolBaseOverviewCTO.symbol}
                    liquidityTokenSymbol={poolBaseOverviewCTO.liquidityTokenSymbol}
                    toolTip="The maximum amount of USDC you can request to be withdrawn, either via early withdrawal request or rollover termination notice."
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <ViewField
                    dataObject={poolBaseAccountCTOAtBlock}
                    poolTokenSymbol={poolBaseOverviewCTO.symbol}
                    fieldSchema={PoolAccountCTOSchema.describe().fields.maxRedeemRequest}
                    toolTip="The maximum number of vault tokens you can request to be redeemed. This applies for both Rollover Terminations and Early Withdrawal Requests."
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <ViewField
                    dataObject={poolBaseAccountCTOAtBlock}
                    fieldSchema={PoolAccountCTOSchema.describe().fields.maxRedeem}
                    poolTokenSymbol={poolBaseOverviewCTO.symbol}
                    toolTip="After your withdrawal request or rollover termination has been processed and USDC is repaid into the Loan Vault, this is the maximum number of tokens you can redeem for USDC."
                  />
                </Grid>

                {!poolDynamicAccountCTO && (
                  <Grid item xs={12} sm={6}>
                    <ViewField
                      dataObject={poolBaseAccountCTOAtBlock}
                      fieldSchema={PoolAccountCTOSchema.describe().fields.maxWithdraw}
                      liquidityTokenSymbol={poolBaseOverviewCTO.liquidityTokenSymbol}
                    ></ViewField>
                  </Grid>
                )}

                <Grid item xs={12} sm={6}>
                  <ViewField
                    dataObject={poolBaseAccountCTOAtBlock}
                    fieldSchema={PoolAccountCTOSchema.describe().fields.principalEarningInterest}
                    liquidityTokenSymbol={poolBaseOverviewCTO.liquidityTokenSymbol}
                  ></ViewField>
                </Grid>
                {!poolDynamicAccountCTO && (
                  <Grid item xs={12} sm={6}>
                    <ViewField
                      dataObject={poolBaseAccountCTOAtBlock}
                      fieldSchema={PoolAccountCTOSchema.describe().fields.assetsTransferringIn}
                      liquidityTokenSymbol={poolBaseOverviewCTO.liquidityTokenSymbol}
                    ></ViewField>
                  </Grid>
                )}
                {!poolDynamicAccountCTO && (
                  <Grid item xs={12} sm={6}>
                    <ViewField
                      dataObject={poolBaseAccountCTOAtBlock}
                      fieldSchema={PoolAccountCTOSchema.describe().fields.assetsTransferringOut}
                      liquidityTokenSymbol={poolBaseOverviewCTO.liquidityTokenSymbol}
                    ></ViewField>
                  </Grid>
                )}
                {!poolDynamicAccountCTO && (
                  <Grid item xs={12} sm={6}>
                    <ViewField
                      dataObject={poolBaseAccountCTOAtBlock}
                      fieldSchema={PoolAccountCTOSchema.describe().fields.expectedInterestAtMaturity}
                      liquidityTokenSymbol={poolBaseOverviewCTO.liquidityTokenSymbol}
                    ></ViewField>
                  </Grid>
                )}
              </>
            )}
          </Grid>
          <SectionHeader>
            <Typography variant={'captionBold'}>Vault Transactions</Typography>
          </SectionHeader>

          <Grid container spacing={8} sx={{ padding: '24px', marginTop: '-24px', marginLeft: '0px' }}>
            {poolDynamicAccountCTO && (
              <>
                <Grid item xs={12} sm={6}>
                  <ViewField
                    dataObject={poolDynamicAccountCTO!}
                    poolTokenSymbol={poolBaseOverviewCTO.symbol}
                    fieldSchema={PoolDynamicAccountCTOSchema.describe().fields.requestedAssetsOf}
                  ></ViewField>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <ViewField
                    dataObject={poolDynamicAccountCTO!}
                    poolTokenSymbol={poolBaseOverviewCTO.symbol}
                    fieldSchema={PoolDynamicAccountCTOSchema.describe().fields.maxWithdrawRequest}
                  ></ViewField>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <ViewField
                    dataObject={poolDynamicAccountCTO!}
                    fieldSchema={PoolDynamicAccountCTOSchema.describe().fields.acceptedAssets}
                    poolTokenSymbol={poolBaseOverviewCTO.symbol}
                    liquidityTokenSymbol={poolBaseOverviewCTO.liquidityTokenSymbol}
                  ></ViewField>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <ViewField
                    dataObject={poolDynamicAccountCTO!}
                    poolTokenSymbol={poolBaseOverviewCTO.symbol}
                    fieldSchema={PoolDynamicAccountCTOSchema.describe().fields.assetsWithdrawn}
                    liquidityTokenSymbol={poolBaseOverviewCTO.liquidityTokenSymbol}
                  ></ViewField>
                </Grid>
              </>
            )}
            {poolFlexAccountCTO && (
              <>
                <Grid item xs={12} sm={6}>
                  <ViewField
                    dataObject={poolFlexAccountCTO!}
                    poolTokenSymbol={poolBaseOverviewCTO.symbol}
                    fieldSchema={PoolFlexAccountCTOSchema.describe().fields.requestedAssetsOf}
                  ></ViewField>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <ViewField
                    dataObject={poolFlexAccountCTO!}
                    poolTokenSymbol={poolBaseOverviewCTO.symbol}
                    fieldSchema={PoolFlexAccountCTOSchema.describe().fields.maxWithdrawRequest}
                  ></ViewField>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <ViewField
                    dataObject={poolDynamicAccountCTO!}
                    poolTokenSymbol={poolBaseOverviewCTO.symbol}
                    fieldSchema={PoolFlexAccountCTOSchema.describe().fields.assetsDueForWithdraws}
                    liquidityTokenSymbol={poolBaseOverviewCTO.liquidityTokenSymbol}
                  ></ViewField>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <ViewField
                    dataObject={poolFlexAccountCTO!}
                    poolTokenSymbol={poolBaseOverviewCTO.symbol}
                    fieldSchema={PoolFlexAccountCTOSchema.describe().fields.assetsWithdrawn}
                    liquidityTokenSymbol={poolBaseOverviewCTO.liquidityTokenSymbol}
                  ></ViewField>
                </Grid>
              </>
            )}
          </Grid>
          <Box sx={{ marginTop: 2 }}>
            {poolFlexAccountCTO && <LenderInvestmentLedger poolAddr={poolAddr} lenderAddr={accountAddr} />}
            {poolTermAccountCTO && <LenderInvestmentLedger poolAddr={poolAddr} lenderAddr={accountAddr} />}
            {poolDynamicAccountCTO && <LenderInvestmentLedger poolAddr={poolAddr} lenderAddr={accountAddr} />}
          </Box>
        </Box>
      </Box>
    )
  } else {
    return <></>
  }
}
